<!--
  @description 工作台
  @author cjs1992
  @date 2020-09-01 16:46:02
-->
<template>
  <div>
    <div class="mainContent topPart">
      <div class="headerAndNav">
        <v-header></v-header>
        <!-- <v-nav :index="null"></v-nav> -->
      </div>
      <div class="topQuery">
        <div class="mainWidth clearfix">
          <h2 class="partName pull-right">工作台/<span>Work Bench</span></h2>
        </div>
      </div>
    </div>
    <div class="userContent clearfix mainWidth">
      <div class="left">
        <div class="headerImg">
          <img src="../../../static/images/u2551.png" alt="">
        </div>
        <div class="userTab">
          <!-- <div class="header_image">
            <img src="../../../static/images/u2551.png" alt="">
          </div> -->
          
          <div class="namePart">
            <b>{{$store.state.nickName}}</b>
            <p> <span v-for="(item,index) in roleNameList" :key="`role${index}`" style="padding: 0 5px;">{{item.roleName}}</span>
            <br />
              <span v-for="(item,index) in $store.state.departName" :key="index">{{index !== 0 ? "/" : ""}}{{item.deptName}}</span>
            </p>
          </div>
          <div class="userTabContent clearfix">
            <div class="tab_list_wrap">
              <div class="tab_item_wrap"
                v-for="(item, index) in tabList"
                :key="index"
              >
                <div class="item_title">{{item.name}}</div>
                <div class="item_child_list_wrap">
                  <div class="item_child_item_wrap"
                    v-for="(vo, i) in item.children"
                    :key="`${index}_${i}`"
                    :class="{
                      active: currentTab === vo.value
                    }"
                    @click="tabItemClickFunc(vo)"
                  >{{vo.name}}</div>
                </div>
              </div>
            </div>
            <!-- <div :class="{active:userTabIndex == 0}">
              <ul class="noselect">
                <li v-for="(item,index) in ywtbNav" :key="`ywtbNav_${index}`" :class="{active:index == ywtbIndex}"
                  @click="itemsChange_0(index)"><i class="iconfont" :class="item.fontClass"></i>
                  {{item.name}}
                  <div class="badge" v-if="item.badge">{{item.badge}}</div>
                </li>
              </ul>
            </div> -->
          </div>
        </div>

      </div>
      <div class="right">
        <div v-show="userTabIndex === 0">
          <v-approvalWork v-if="currentTab <= 4" :flag="currentTab"></v-approvalWork>
          <v-inquiryReply v-else-if="currentTab <= 6" :flag="currentTab"></v-inquiryReply>
          <v-evaluationReview v-else-if="currentTab <= 9" :flag="currentTab"></v-evaluationReview>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
    <v-toolBar></v-toolBar>
  </div>
</template>

<script>
  import Footer from '../common/Footer'
  import Header from './header.vue'
  // import TopNav from '../common/TopNav'
  import ToolBar from '../common/ToolBar'
  import InquiryReply from './InquiryReply'
  import EvaluationReview from './EvaluationReview'
  import ApprovalWork from './ApprovalWork'
  import qs from 'qs';
  export default {
    components: {
      'v-footer': Footer,
      'v-header': Header,
      // 'v-nav': TopNav,
      'v-toolBar': ToolBar,
      'v-inquiryReply': InquiryReply,
      'v-evaluationReview': EvaluationReview,
      'v-approvalWork': ApprovalWork
    },
    computed: {
      roleNameList() {
        const list = this.$store.state.roleName || [];
				const arr = list.filter((item) => item.roleType !== "2");
				return arr;
      }
    },
    data() {
      return {
        userTabIndex: 0,
        navIndex: 2,
        ywtbIndex: 0,
        gztIndex: 0,
        currentTab: 1,
        tabList: [
          {
            name: "审批工作",
            children: [
              { name: "待办事项", value: 1 },
              { name: "待阅事项", value: 2 },
              { name: "已办事项", value: 3 },
              { name: "已阅事项", value: 4 }
            ]
          },
          {
            name: "咨询回复",
            children: [
              { name: "已回复咨询", value: 5 },
              { name: "未回复咨询", value: 6 },
            ]
          },
          {
            name: "评价审核",
            children: [
              { name: "待审核评价", value: 7 },
              { name: "已通过评价", value: 8 },
              { name: "未通过评价", value: 9 }
            ]
          }
        ],
        ywtbNav: [{
          name: '我的办件',
          num: 11,
          badge: 0,
          fontClass:'icon-sx'
        }, {
          name: '我的咨询',
          num: 8,
          badge: 0,
          fontClass:'icon-zx'
        }, {
          name: '我的评价',
          num: 99,
          badge: false,
          fontClass:'icon-pj'
        }, {
          name: '我的收藏',
          num: 128,
          badge: false,
          fontClass:'icon-sc'
        }, {
          name: '审批工作',
          num: 11,
          badge: 0,
          fontClass:'icon-spgz'
        }, {
          name: '咨询回复',
          num: 10,
          badge: 0,
          fontClass:'icon-zxhf'
        }, {
          name: '评价审核',
          num: 10,
          badge: 0,
          fontClass:'icon-pjsh'
        },
        {
          name: "我的工作台",
          num: 0,
          badge: 0,
          fontClass: "icon-sx"
        }],
        gzt: [{
          name: '审批工作',
          num: 11,
          badge: 0,
          fontClass:'icon-sx'
        }, {
          name: '咨询回复',
          num: 10,
          badge: 0,
          fontClass:'icon-sx'
        }, {
          name: '评价审核',
          num: 10,
          badge: 0,
          fontClass:'icon-sx'
        }
        ],
        newMsg3: ''
      }
    },
    mounted() {
      let userSite0 = localStorage.getItem('userSite0')
      if (userSite0) {
        this.ywtbIndex = parseInt(userSite0)
      }
       localStorage.setItem('userSite0','')
      // this.getNewMsg0()
      // this.getNewMsg2()
      // this.getNewMsg3()
    },
    methods: {
      /**
       * @name tabItemClickFunc
       * @description 点击tab
       * @param {}
       * @return {}
       * @author cjs1992
       * @date 2020-09-02 10:51:07
       */
      tabItemClickFunc(param) {
        const { value } = param;
        if (this.currentTab === value) {
          return;
        }
        this.currentTab = value;
      },
      /**
       * @name changeGztBadge
       * @description 更改工作台的badge状态
       * @param {}
       * @return {}
       * @author cjs1992
       * @date 2020-07-31 10:03:22
       */
      changeGztBadge(index, count) {
        try {
          this.$set(this.ywtbNav[index], "badge", count);
        } catch (error) {
          // 没有这个下标
        }
      },
      userTabChange(index) {
        // console.log(index)
        this.userTabIndex = index
      },
      handleEdit(index, row) {
        console.log(index, row);
      },
      handleDelete(index, row) {
        console.log(index, row);
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      itemsChange_0(idx) {
        this.ywtbIndex = idx
        if (idx === 7) {
          // 跳转到我的工作台
          this.$router.push({
            path: "/workbench"
          })
        }
        // console.log(idx)
      },
      itemsChange_1(idx) {
        this.gztIndex = idx
      },
      change2(data) {
        // console.log(data)
        this.gzt[2].badge = data
      },
      //获取办事台未回复的数量
      getNewMsg2() {
        let sendData = qs.stringify({
          type: 0,
          // memberId: this.$store.state.userId
        })
        this.ywtbRequest('/portal-ywtb/web/consultation/listUnreadCountByCondition', sendData).then(res => {
          this.ywtbNav[5].badge = res.count
        })
      },
      //获取办事台未审核数量
      getNewMsg3() {
        let sendData = qs.stringify({
          type: 0,
          memberId: this.$store.state.userId
        })
        this.ywtbRequest('/portal-ywtb/web/guidelineSuggestion/listUnreadSuggestionCountByCondition',
          sendData).then(res => {
          this.ywtbNav[6].badge = res.count
        })
      },
      // 获取我的咨询新动态数量
      getNewMsg0() {
        let sendData = qs.stringify({
          // memberId: this.$store.state.userId
        })
        this.ywtbRequest('/portal-ywtb/web/consultation/findNewConsultationByMemberId').then(res => {
          this.ywtbNav[1].badge = res.count
        })
      },
      changeMyItemNum(num) {
        this.ywtbNav[0].badge = num
      },
      changeWorkNum(num) {
        this.ywtbNav[4].badge = num
      }
    }
  }

</script>

<style scoped>
  h2.partName {
    color: #fff;
    font-size: 42px;
    font-weight: 500;
    margin-bottom: 28px;
    margin-top: 45px;
    margin-right: 30px;
  }

  .pageName {
    position: absolute;
    top: -43px;
    right: -10px;
    width: 113px;
    height: 33px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, .46);
    border-radius: 17px;
  }

  h2.partName span {
    color: #B7BFC9;
    font-size: 16px;
  }

  .headerAndNav {
    /* background: linear-gradient(0deg, rgba(12, 50, 135, 1) 0%, rgba(10, 46, 129, 1) 100%); */
    background-color: rgba(5, 57, 130, 1);
  }

  .topQuery {
    background: url(../../../static/images/userBg.png) no-repeat 0px 0px;
    height: 149px;
    background-size: 100% 160%;
    padding: 0;
  }

  .topQuery>div {
    position: relative;
  }

  .userContent {
    position: relative;
    min-height: 400px;
  }

  .userContent .left {
    position: absolute;
    width: 253px;
    top: -121px;
    /* top: 0; */
    left: 0;
    /* background-color: #fff; */
    z-index: 22;
  }

  .userContent .right {
    padding-left: 278px;
    padding-right: 10px;
    margin-bottom: 30px;
    min-height: 710px;
  }

  .headerImg {
    width: 100%;
    height: 121px;
    background: url(../../../static/images/headerImg.png) no-repeat 0px 0px;
    background-size: 100% 100%;
    position: relative;
  }

  .headerImg img {
    width: 82px;
    height: 82px;
    border-radius: 50%;
    position: absolute;
    left: 82px;
    top: 17px;
  }

  .userTab {
    width: 100%;
    padding: 0 15px;
    min-height: 657px;
    box-shadow: 2px 2px 12px #b3b2b2;
    border-radius: 0 0 12px 12px;
  }

  .namePart {
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #EDEFF2;
    height: 76px;
  }

  .namePart b {
    font-size: 20px;
    color: #091B28;
  }

  .namePart p {
    color: #B6C4CF;
    margin-top: 10px;
  }

  .userTab .tabTit span {
    float: left;
    width: 106px;
    height: 44px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 22px;
    color: #666666;
    font-size: 16px;
    text-align: center;
    line-height: 44px;
    padding: 0;
  }

  .userTab .tabTit {
    padding-top: 18px;
  }

  .userTab .tabTit span:last-child {
    float: right;
  }

  .userTab .tabTit span.active {
    color: #fff;
    background-color: #446EFF;
  }

  .userTab .userTabContent>div {
    display: none;
    padding-top: 10px;
  }

  .userTab .userTabContent>div.active {
    display: block;
  }

  .userTabContent ul li {
    line-height: 54px;
    position: relative;
    padding-left: 20px;
    color: #B6C4CF;
    font-size: 16px;
    cursor: pointer;
  }

  .userTabContent ul li.active {
    color: #446EFF;
  }

  .userTabContent ul li i {
    margin-right: 6px;
    font-size: 16px;
   vertical-align: middle;
  }

  .badge {
    position: absolute;
    top: 2px;
    left: 114px;
    min-width: 20px;
    text-align: center;
    color: #fff;
    background-color: red;
    border-radius: 10px;
    line-height: 20px;
    padding: 0 4px;
    font-size: 12px;
  }

</style>
<style lang="scss" scoped>
.header_image {
  width: 80px;
  height: 80px;
  border-radius: 40px;;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 20px;
  box-sizing: content-box;
  img {
    width: 100%;
    height: 100%;
  }
}
.namePart {
  height: 90px;
}
.tab_list_wrap {
  display: block !important;
  .tab_item_wrap {
    .item_title {
      font-size: 15px;
      color: #444;
      font-weight: 700;
      // height: 24px;
      padding: 4px 0;
    }
    .item_child_list_wrap {
      .item_child_item_wrap {
        font-size: 14px;
        color: #999;
        height: 36px;
        line-height: 36px;
        padding-left: 14px;
        position: relative;
        cursor: pointer;
        transition: all .3s;
        &.active {
          background-color: #EBEEFD;
          color: #849FFE;
          &::before {
            position: absolute;
            height: 36px;
            content: " ";
            width: 2px;
            top: 0;
            left: 0;
            background-color: #849FFE;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workbench/index.vue